import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useState, useEffect } from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';
import useCanvasId from '../../utils/useCanvasId.js';

var _excluded = ["aria-label", "className", "checked", "defaultValue", "defaultChecked", "disabled", "error", "highlight", "label", "id", "onChange", "value"];
var InputToggle = function InputToggle(_ref) {
  var ariaLabel = _ref['aria-label'],
    className = _ref.className;
    _ref.checked;
    var defaultValue = _ref.defaultValue,
    defaultChecked = _ref.defaultChecked,
    disabled = _ref.disabled,
    error = _ref.error,
    highlight = _ref.highlight,
    label = _ref.label,
    id = _ref.id,
    onChange = _ref.onChange,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('InputToggle', otherProps);
  var finalClasses = classnames('C-Toggle', {
    isDisabled: disabled,
    isErrored: error,
    isHighlighted: highlight
  }, className);
  var uuid = useCanvasId(id, 'Toggle');
  var _useState = useState(value || defaultChecked || defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setIsChecked = _useState2[1];
  useEffect(function () {
    if (value != undefined) {
      setIsChecked(value);
    }
  }, [value]);
  var handleOnChange = function handleOnChange(event) {
    setIsChecked(event.target.checked);
    onChange && onChange(event);
  };
  if (!label && !ariaLabel) {
    console.error("Hey Canvas User! Your Toggle input needs either a label or aria-label to tell screen readers what it represents.", {
      id: id,
      label: label
    });
  }
  if (typeof value != 'boolean') {
    console.error("Hey Canvas User! Your Toggle input appears to be using a non boolean value.", {
      id: id,
      value: value
    });
  }
  return /*#__PURE__*/React__default.createElement("label", {
    "aria-label": ariaLabel,
    htmlFor: id,
    className: finalClasses
  }, /*#__PURE__*/React__default.createElement("input", _extends({
    id: id ? id : uuid,
    className: "C-Toggle__Input",
    checked: isChecked,
    disabled: disabled,
    type: "checkbox",
    onChange: handleOnChange,
    value: isChecked
  }, otherProps)), /*#__PURE__*/React__default.createElement("span", {
    className: "C-Toggle__Slider"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "C-Toggle__Label"
  }, label));
};
InputToggle.displayName = 'Input.Toggle';

export { InputToggle as default };
